<template>
  <el-dialog title="选择预售商品" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
             :close-on-press-escape="false" width="900px">
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="预售方案名称">
          <el-input placeholder="请输入预售方案名称" v-model="formInline.title">
            <el-button slot="append" icon="el-icon-productName" @click="getData">查询</el-button>
          </el-input>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="productList" border style="width: 100%" highlight-current-row v-loading="loading"
                  @selection-change="tableCurrentChange">
          <el-table-column width="70" label="商品图片">
            <template slot-scope="scope">
              <img :src="scope.row.imagePath" width="30" height="30"/>
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="商品名称"></el-table-column>
          <el-table-column prop="title" label="方案名称" width="180"></el-table-column>
          <el-table-column prop="presellStartTime" label="开始时间" width="150"></el-table-column>
          <el-table-column prop="presellEndTime" label="结束时间" width="150"></el-table-column>
          <el-table-column type="selection" :selectable="selectableFunc" width="44"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage" :page-sizes="[2, 10, 20, 50, 100]" :page-size="pageSize"
                       layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible=false">取 消</el-button>
      <el-button size="small" type="primary" @click="addClerk">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ProductApi from '@/api/product.js'

export default {
  name: 'PresaleProduct',
  data () {
    return {
      /*是否加载完成*/
      loading: true,
      /*当前是第几页*/
      curPage: 1,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      dialogVisible: false,
      formInline: {
        title: '',
      },
      //商品列表
      productList: [],
      multipleSelection: [],
      params: null
    }
  },
  props: ['excludePresaleIds', 'shopSupplierId'],
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    /*是否可以勾选*/
    selectableFunc (e) {
      if (typeof e.noChoose !== 'boolean') {
        return true
      }
      return e.noChoose
    },
    show () {
      this.dialogVisible = true
      this.curPage = 1
      this.getData()
    },

    /*获取商品列表*/
    getData () {
      let self = this
      self.loading = true
      let Params = self.formInline
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize

      ProductApi.supplierPresaleList(Params, true)
        .then(res => {
          self.loading = false
          if (self.excludePresaleIds && typeof (self.excludePresaleIds) != 'undefined' && self.excludePresaleIds.length > 0) {
            res.data.records.forEach(item => {
              delete item.productId
              if (self.excludePresaleIds.indexOf(item.id) > -1) {
                item.noChoose = false
              } else {
                item.noChoose = true
              }
            })
          }
          self.productList = res.data.records
          self.totalDataNumber = res.data.total
        })
        .catch(error => {
          self.loading = false
        })
    },
    addClerk () {
      let self = this
      let params = null
      if (self.multipleSelection.length < 1) {
        self.$message({
          message: '请至少选择一件预售商品！',
          type: 'error'
        })
        return
      }
      self.multipleSelection.forEach(item => {
        item.image = item.imagePath
      })
      params = self.multipleSelection
      self.params = params
      this.$emit('closeDialog', {
        params: self.params
      }, this.hidden)
    },
    hidden () {
      this.dialogVisible = false
    },
    /*关闭弹窗*/
    dialogFormVisible () {
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      this.curPage = val
      this.getData()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getData()
    },

    /*监听复选按钮选中事件*/
    tableCurrentChange (val) {
      this.multipleSelection = val
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/PresaleProduct.vue